import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  countries: [],
  businessUnits: [],
  sortedBusinessUnits: [],
  selectedBusinessUnit: {}
};

const registerSlice = createSlice({
  name: "techsbook",
  initialState,
  reducers: {
    setCountries(state, action) {
      state.countries = action?.payload;
    },
    setSelectedBusinessUnit(state, action) {
      console.log('payload', action.payload)
      state.selectedBusinessUnit = action?.payload;
    },
    setBusinessUnits(state, action) {
      state.businessUnits = action?.payload;
    },
    filterUnits(state, action){
      state.sortedBusinessUnits = action.payload?.map(unit => {
        return { label: unit?.company_name, value: unit?.country_id }
      })
    }
  }
});

export const {
  setCountries,
  setSelectedBusinessUnit,
  setBusinessUnits,
  filterUnits,
} =
  registerSlice.actions;

export default registerSlice.reducer;
